/* eslint-disable no-param-reassign */
import { createSlice, createAction } from '@reduxjs/toolkit';

import initialState from '../../../domain/app/entities/informar';


// ---------------- Saga's response ----------------
function fetchInformarSuccess(state, action) {
  const { respuestaServicio } = action.payload;
  state.response = respuestaServicio;
  state.errorFetchConfirmar = false;
}

function fetchInformarError(state) {
  state.response = [];
  state.errorFetchConfirmar = true;
}


const fetchInformar = createAction('fetchInformar');

// ------------- connection ------------- //

const informarReducer = createSlice({
  name: 'Informar',
  initialState,
  reducers: {
    fetchInformarSuccess,
    fetchInformarError,
  },
});

export const informarAction = {
  ...informarReducer.actions,
  fetchInformar,
};

export default informarReducer.reducer;